// src/components/ImageWithLoader.js (or wherever you prefer to put helper components)
import React, { useState } from 'react';
import { CircularProgress, Avatar, Box } from '@mui/material';

const ImageWithLoader = ({ imageUrl, altText }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  // Determine the source for the Avatar
  let actualSrc = imageUrl;
  if (hasError || !imageUrl) { // If there's an error or no URL, use default
    actualSrc = "/default-image.png"; // Make sure this path is correct for your app's default image
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ width: 40, height: 40, margin: "auto", position: 'relative' }}
    >
      {/* Show spinner only if image is not loaded and no error, and there's an actual URL to load */}
      {!imageLoaded && !hasError && imageUrl && (
        <CircularProgress size={20} color="primary" sx={{ position: 'absolute' }} />
      )}
      
      {/* Avatar component */}
      <Avatar
        src={actualSrc}
        alt={altText}
        sx={{
          width: 40,
          height: 40,
          margin: "auto",
          // Only display the Avatar if the image is loaded OR if there was an error/no URL (to show fallback)
          visibility: (imageLoaded || hasError || !imageUrl) ? "visible" : "hidden",
        }}
        variant="rounded"
        onLoad={() => {
          if (!hasError) { // Only set loaded if no prior error
            setImageLoaded(true);
          }
        }}
        onError={(e) => {
          setImageLoaded(true); // Treat as loaded to hide spinner
          setHasError(true);    // Mark that an error occurred
          // The src is already handled by actualSrc, no need to directly set e.target.src here
        }}
      />
    </Box>
  );
};

export default ImageWithLoader;